import { CSSProperties } from "react"
import { useHistory } from "react-router-dom"
import { CurrentBrand, SpotifyArtistInBrandConnections, SpotifyArtistSearchResponse } from "modules/Types"
import useBrand from 'Hooks/useBrand'
import ArtistItem from "components/shareable/ArtistItem"
import ModalSymphony from "elements/ModalSymphony"
import ButtonSymphony from "elements/ButtonSymphony"
import { checkIfSpotifyArtistExistsForUser_api } from "api/brandApi"
import { clsx, styx } from "modules/Utils"

interface Props {
    className: string
    style?: CSSProperties
    isOpen: boolean
    artist: SpotifyArtistInBrandConnections | SpotifyArtistSearchResponse
    brandOverride?: CurrentBrand | undefined
    onClose: () => void
    onGoToDashboardCallback?: () => void
    buttonLabel?: string
}

const AlreadyExistingArtistModal = ({
    className,
    style,
    isOpen,
    artist,
    brandOverride,
    onClose = () => { },
    onGoToDashboardCallback = () => { },
    buttonLabel = 'Go to Artist Dashboard'
}: Props) => {
    const history = useHistory()
    const { currentBrand, setCurrentBrand } = useBrand()

    const goToDashboard = async () => {
        if (brandOverride) {
            setCurrentBrand(brandOverride)
        } else if (artist) {
            const res = await checkIfSpotifyArtistExistsForUser_api(artist?.id || null)
            const {
                data: brandFromSpotifyId,
                error: brandFromSpotifyIdError
            }: {
                data: CurrentBrand | null
                error: unknown | null
            } = res

            if (brandFromSpotifyId?.id !== currentBrand?.id && !!brandFromSpotifyIdError) {
                setCurrentBrand(brandFromSpotifyId!)
            }
        }
        onGoToDashboardCallback()
        history.push('/dashboard')
    }

    return (
        <ModalSymphony
            className={clsx("alreadyExistingArtistModal1", className)}
            style={styx(style)}
            isOpen={isOpen}
            onClose={onClose}
            title="You've already added this artist."
            subtitle={`Looks like you've already added ${artist?.name || ''} to the artists under your profile.`}
        >
            <ArtistItem
                className="alreadyExistingArtistModalArtistItem"
                artist={artist}
                selectArtist={goToDashboard}
                buttonLabel={buttonLabel}
            />
            <ButtonSymphony
                className="alreadyExistingArtistModalButton"
                style={{ marginTop: 24, flexShrink: 0 }}
                onClick={onClose}
                variant="outlined"
            >
                Search for another artist
            </ButtonSymphony>
        </ModalSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    modalConnectButtonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
        height: 44,
        flex: 'none',
        order: 2,
        alignSelf: 'stretch',
        flexGrow: 0,
    }
}

export default AlreadyExistingArtistModal
